module.exports = __webpack_public_path__ + "static/img/mission-modular-3.bb609299.png";